import { datadogLogs } from "@datadog/browser-logs";
import { getVar } from "config";

const isLocalhost = getVar("REACT_APP_ENV") === "localhost";

datadogLogs.logger.setHandler(isLocalhost ? ["console", "http"] : "http");
export default datadogLogs.logger;
